<template>
  <div style="margin-top: 24px; padding-bottom: 20px">
    <a-table
      :loading="loading"
      :scroll="{ x: 500 }"
      :columns="columns"
      :data-source="list"
      class="nopaddingEstimateTable"
      :pagination="false"
      style="margin: -20px 0 0 0"
    >
      <template v-for="el in fixedArr" :slot="el" slot-scope="text, r">
        <span :key="el" v-if="r.name === '生产成本降低'">
          {{ r[el] ? Number(r[el] * 100).toFixed(2) : "-" }}
        </span>
        <span :key="el" v-else-if="r.name === '经济效益提升率'">
          {{ r[el] ? Number(r[el] * 100).toFixed(2) : "-" }}
        </span>
        <span :key="el" v-else>
          {{ r[el] ? Number(r[el]).toFixed(2) : "-" }}
        </span>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  economicColums,
  economicList,
} from "../../../../EstimateConfig/estimateConfig";
import { mapState } from "vuex";
export default {
  props: ["details"],
  data() {
    return {
      list: [],
      loading: false,
      sectionList: [],
      economicList,
      fixedArr: [], //保存观测值数据，省略后两位
      energySystemName: "",
    };
  },
  computed: {
    ...mapState("estimate", ["dataDictionary"]),
    columns() {
      let newColumns = this.dealColumns();
      return newColumns;
    },
  },
  watch: {
    details: {
      handler(data) {
        let { prediction } = data;
        this.getName();
        this.getDetails(prediction.id);
      },
      deep: true,
    },
  },

  methods: {
    dealColumns() {
      let newColumns = [...economicColums];
      if (this.sectionList.length > 1) {
        this.sectionList.forEach((el, index) => {
          newColumns.push({
            title: el.name,
            children: [
              {
                title: "预估值",
                dataIndex: `f${index}`,
                scopedSlots: { customRender: `f${index}` },
                width: 100,
              },
            ],
          });
        });
      } else {
        newColumns.push({
          title: "预估值",
          dataIndex: "f0",
          scopedSlots: { customRender: `f0` },
        });
      }
      return newColumns;
    },

    getDetails(predictionId) {
      if (!predictionId) {
        return;
      }
      this.loading = true;
      this.$get(
        "/sat-maximization/opeconomicbenefit/opEconomicBenefitByPredictionId",
        { predictionId }
      )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            this.loading = false;

            let { opEconomicBenefitVOList } = data;

            let message = data.messageList.join(";");
            if (message != "") {
              this.$message.warning(message, 6);
            }

            //动态生成头部区间
            if (opEconomicBenefitVOList && opEconomicBenefitVOList.length > 0) {
              opEconomicBenefitVOList.forEach((el, index) => {
                this.sectionList.push({
                  name: `${el.feedingprogramStartWeight}-${el.feedingprogramEndWeight}kg`,
                  field: `${el.feedingprogramStartWeight}-${el.feedingprogramEndWeight}`,
                });
                this.fixedArr.push(`f${index}`);
              });
            } else {
              this.fixedArr.push(`f0`);
            }

            //动态生成数据
            let list = [];
            this.economicList.forEach((item) => {
              if (
                item.name.includes("[能量体系名称]") &&
                this.energySystemName
              ) {
                item.name = item.name.replace(
                  "[能量体系名称]",
                  this.energySystemName
                );
              }

              let obj = {
                name: item.name,
                unit: item.unit,
              };

              //动态生成数据
              opEconomicBenefitVOList.forEach((el, index) => {
                if (item.filed === "proCostRatio") {
                  obj[`f${index}`] = el.opEconomicBenefitTotal.proCostRatio;
                } else if (item.filed === "ecoRatio") {
                  obj[`f${index}`] = el.opEconomicBenefitTotal.ecoRatio;
                } else if (item.filed === "highEco") {
                  obj[`f${index}`] = el.opEconomicBenefitTotal.highEco;
                } else if (item.filed === "currentEco") {
                  obj[`f${index}`] = el.opEconomicBenefitTotal.currentEco;
                } else {
                  obj[`f${index}`] = el[`${item.filed}`];
                }
              });
              if(item.filed === 'currentDietPrice' || item.filed === 'lowProCostDietPirce'){
                obj.f0 = obj.f0 ? obj.f0 * 1000 : null
                console.log('item',item)
                console.log('obj',obj)
              }

              list.push(obj);
            });
            this.list = list; //赋值
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //能量体系名称
    getName() {
      let { prediction } = this.details;
      let { energySystem } = prediction;
      let obj = this.dataDictionary.EnergySystem.find(
        (el) => el.dictKey === energySystem
      );
      this.energySystemName = obj.dictValue.replace("体系", "") || " ";
    },
  },
};
</script>